import { gql } from 'graphql-request';

import graphClient from './graph_client';
import type { CoveragePayload } from '../mapCoverageSignal';

export const MapNohitEventCreate = gql`
  mutation MapNohitEventCreate($input: MapNohitEventCreateInput!) {
    mapNohitEventCreate(input: $input) {
      created
    }
  }
`;

/**
 * Fire-and-forget. This is a background analytics signal — it must never
 * surface an error to the user or block the map, and a logged-out visitor is
 * a perfectly valid source (the backend records those with a null user).
 */
export function sendMapCoverageEvent(payload: CoveragePayload): void {
  graphClient
    .request(MapNohitEventCreate, { input: payload })
    .catch((error: unknown) => {
      console.debug('[MapCoverage] failed to report empty viewport', error);
    });
}
